import axiosClient from '../axiosClient';
import { ENDPOINT } from '../endpoint';

export const GameIntroductionService = {
  getList: (params?: any) => {
    return axiosClient.get(ENDPOINT.GAME_INTRODUCTION.GET_LIST, { params });
  },
  getDetail: (id: number) => {
    return axiosClient.get(
      ENDPOINT.GAME_INTRODUCTION.GET_DETAIL.replace(':id', String(id)),
    );
  },
  create: (body: any) => {
    return axiosClient.post(ENDPOINT.GAME_INTRODUCTION.CREATE, body);
  },
  update: (body: any, id: number) => {
    return axiosClient.put(
      ENDPOINT.GAME_INTRODUCTION.UPDATE.replace(':id', String(id)),
      body,
    );
  },
  delete: (id: number) => {
    return axiosClient.delete(
      ENDPOINT.GAME_INTRODUCTION.DELETE.replace(':id', String(id)),
    );
  },
};
